import { http } from 'http';

export default {
  startSessionApi: credentials =>
    http.post(
      '/auth/token',
      {
        Client_Id: credentials.clientId,
        Client_Secret: credentials.clientSecret,
        Scope: credentials.scope,
        Grant_Type: credentials.grantType
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        loading: false
      }
    )
};
